import { useTranslation } from 'react-i18next';
import type { ScreenConnectionCounts } from '../../lib/dashboard/screenStatus';
import { buildDisplaysHealthSummary } from './buildDisplaysHealthSummary';

type DisplaysMobileHealthProps = {
  counts: ScreenConnectionCounts;
  locationCount: number;
};

/** One-line fleet health for the companion Displays surface. */
export function DisplaysMobileHealth({ counts, locationCount }: DisplaysMobileHealthProps) {
  const { t } = useTranslation('displays');
  const summary = buildDisplaysHealthSummary(counts, locationCount);

  return (
    <div
      className="flex flex-wrap items-baseline gap-x-2 gap-y-1 rounded-[12px] border px-3.5 py-3 lg:hidden"
      style={{ background: 'var(--gs-panel)', borderColor: 'var(--gs-line)' }}
      aria-label={t('health.aria')}
    >
      <span className="text-[15px] font-bold" style={{ color: 'var(--gs-ink)' }}>
        {summary.totalLabel}
      </span>
      {summary.locationLabel ? (
        <span className="text-[13px]" style={{ color: 'var(--gs-muted)' }}>
          · {summary.locationLabel}
        </span>
      ) : null}
      <span className="text-[13px]" style={{ color: 'var(--gs-muted)' }}>
        · {summary.highlights.join(' · ')}
      </span>
    </div>
  );
}
